import React from 'react'

const HDCAMEDITING = () => {
  return (
    <div>HDCAMEDITING</div>
  )
}

export default HDCAMEDITING